export default __webpack_public_path__ + "static/media/Checked_Icon.e10651aa.svg";